export { default as SendImagesToWhiteboardPageDynamicModalButton } from './SendImagesToWhiteboardPageDynamicModalButton';
